import sortBy from 'lodash/sortBy';
import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

const WISHLIST_MODAL_HEADER_TPL = $('#wishlistModalHeaderTemplate').html();
const WISHLIST_MODAL_LISTS_TPL = $('#wishlistModalListsTemplate').html();
const WISHLIST_CREATION_MODAL_HEADER_TPL = $('#wishlistCreationModalHeaderTemplate').html();
const WISHLIST_CREATION_MODAL_FORM_TPL = $('#wishlistCreationModalFormTemplate').html();
const WISHLISTED_CLASS = 'remove';
const UNWISHLISTED_CLASS = 'add';
const WISHLIST_ITEM_CLASS = '.modal__wishlist__item';

export class WishlistModal {
    constructor(opts) {
        this.modal = $('#wishlist-modal');
        this.wishListCreationModal = document.getElementById('wishlist-creation-modal');
        this.creationModal = $('#wishlist-creation-modal');
        this.source = opts.source;
        this.profileItemToggle = opts.profileItemToggle;
        this.profileItems = opts.profileItems;
        this.pageWishlistId = opts.pageWishlistId;
        this.isClient = opts.isClient;

        this.modalHeader = this.modal.find('#wishlist-modal-header');
        this.wishlistCreationBtn = this.modal.find('#wishlist-creation');
        this.wishlistsListContainer = this.modal.find('#wishlist-modal-container');
        this.wishlistsList = this.modal.find('#wishlist-modal-lists');
        this.wishlistSearchInput = this.modal.find('#wishlist-search');

        this.creationModalHeader = this.creationModal.find('#wishlist-creation-modal-header');
        this.creationModalForm = this.creationModal.find('#wishlist-creation-modal-form');
        this.wishlistCreateBtn = this.creationModal.find('#wishlist-create');
        this.wishlistCancelCreationBtn = this.creationModal.find('#wishlist-cancel');

        this.profileId = null;
        this.profileFirstName = null;
        this.allWishlists = [];

        this.wishListCollaborativeValue = false;
        this.updateWishListCollaborativeStatus = this.updateWishListCollaborativeStatus.bind(this);

        this.initHandlers();
    }

    showWishlistModal(tag) {
        this.profileId = tag.attr('data-profileId');
        this.profileFirstName = tag.attr('data-profileFirstName');

        this.generateModalContent();
        this.modal.modal('show');
    }

    async showWishlistCreationModal() {
        this.modal.modal('hide');
        this.generateCreationModalContent();
        this.creationModal.modal('show');
        this.trackHeap('FreelancerListCreationModaleOpens');
        /**
         * Init the listeners for our Joy component
         * We use async/await in order to use the componentOnReady hook
         */
        await this.getSwitchComponentAndAddListener();
    }

    cancelWishlistCreation() {
        this.creationModal.modal('hide');
        this.trackHeap('FreelancerListCreationModaleCloses');
        this.modal.modal('show');
    }

    generateModalContent() {
        // HEADER CONTENT
        this.modalHeader.html(
            Hop.template(WISHLIST_MODAL_HEADER_TPL, {variable: 'm'})({
                profileFirstName: this.profileFirstName,
                isClient: this.isClient,
            }),
        );

        // LISTS CONTENT
        Hop.wishlists.getAllWishlistsOfCurrentUser((wishlists) => {
            this.wishlistsListContainer.removeClass('hidden');
            this.allWishlists = sortBy(wishlists, [(list) => list.name.toLowerCase()], 'asc');
            this.generateWishlistsContent(this.allWishlists);
            this.updateAllWishlistState(this.allWishlists);
        });
    }

    generateWishlistsContent(wishlists) {
        this.wishlistsList.html(
            Hop.template(WISHLIST_MODAL_LISTS_TPL, {variable: 'm'})({
                wishlists,
                profileFirstName: this.profileFirstName,
            }),
        );
    }

    generateCreationModalContent() {
        // HEADER CONTENT
        this.creationModalHeader.html(
            Hop.template(WISHLIST_CREATION_MODAL_HEADER_TPL, {variable: 'm'})({
                profileFirstName: this.profileFirstName,
                isClient: this.isClient,
            }),
        );

        // FORM CONTENT
        this.creationModalForm.html(
            Hop.template(WISHLIST_CREATION_MODAL_FORM_TPL, {variable: 'm'})({
                isClient: this.isClient,
            }),
        );
    }

    updateAllWishlistState(wishlists) {
        let wishlisted;
        let currentListItem;
        wishlists.forEach((wishlist) => {
            wishlisted = false;
            currentListItem = this.wishlistsList.find('[data-wishlistId="' + wishlist.id + '"]');

            for (let i = 0, l = wishlist.profiles.length; i < l; i++) {
                if (this.profileId === wishlist.profiles[i]) {
                    wishlisted = true;
                }
            }

            if (wishlisted) {
                this.updateWishListState('add', currentListItem);
            } else {
                this.updateWishListState('remove', currentListItem);
            }
        });
    }

    updateWishListState(action, listItem) {
        if (action === 'add') {
            listItem.removeClass(UNWISHLISTED_CLASS);
            listItem.addClass(WISHLISTED_CLASS);
            listItem.find(WISHLIST_ITEM_CLASS + '__heart').addClass('joy-i_full');
        } else if (action === 'remove') {
            listItem.removeClass(WISHLISTED_CLASS);
            listItem.addClass(UNWISHLISTED_CLASS);
            listItem.find(WISHLIST_ITEM_CLASS + '__heart').removeClass('joy-i_full');
        }
    }

    updateProfileDisplay(action) {
        if (action === 'add') {
            $(this.profileItems + '[data-profileId="' + this.profileId + '"]').css('display', 'block');
        } else if (action === 'remove') {
            $(this.profileItems + '[data-profileId="' + this.profileId + '"]').css('display', 'none');
        }
    }

    toggleFromWishlist(listItem) {
        const currentAction = listItem.hasClass('add') ? 'add' : 'remove';
        const currentWishlistId = listItem.attr('data-wishlistId');
        const currentWishlist = this.allWishlists.find((list) => list.id === currentWishlistId);
        Hop.wishlists.toggleProfile({
            action: currentAction,
            wishlistId: currentWishlistId,
            profileId: this.profileId,
            source: this.source,
            callback: () => {
                if (currentAction === 'add') {
                    pushNotification(
                        Hop.message('wishlist.modal.creation.added.success.enriched', currentWishlist.url, Hop.escapeHtml(currentWishlist.name)),
                    );
                } else {
                    pushNotification(
                        Hop.message('wishlist.modal.creation.removed.success.enriched', currentWishlist.url, Hop.escapeHtml(currentWishlist.name)),
                    );
                }

                this.updateWishListState(currentAction, listItem);
                if (this.profileItemToggle && this.pageWishlistId === currentWishlistId) {
                    this.updateProfileDisplay(currentAction);
                }
            },
        });
    }

    createWishlist() {
        const wishlistName = this.creationModal.find('#wishlist-name').val();
        const sharedWithinCompany = this.wishListCollaborativeValue;

        Hop.wishlists.createWishlist({
            wishlistName,
            sharedWithinCompany,
            profileIds: [this.profileId],
            callback: (createdWishlist) => {
                this.creationModal.modal('hide');
                this.trackHeap('FreelancerListCreationModaleCloses');
                pushNotification(Hop.message('wishlist.modal.creation.added.success.enriched', createdWishlist.url, Hop.escapeHtml(wishlistName)));
            },
        });
    }

    filterWishlists() {
        const query = this.wishlistSearchInput.val().toLowerCase();
        const filteredWishlists = this.allWishlists.filter((list) => {
            const nameMatches = list.name.toLowerCase().includes(query);
            if (nameMatches) {
                return true;
            }
            return list.ownerFirstname && list.ownerFirstname.toLowerCase().includes(query);
        });
        this.generateWishlistsContent(filteredWishlists);
    }

    initHandlers() {
        this.wishlistSearchInput.on('change keyup', () => this.filterWishlists());
        this.wishlistCreationBtn.on('click', () => this.showWishlistCreationModal());
        this.wishlistCancelCreationBtn.on('click', () => this.cancelWishlistCreation());
        this.wishlistCreateBtn.on('click', () => this.createWishlist());
        this.wishlistsList.on('click', WISHLIST_ITEM_CLASS, (e) => {
            const currentListItem = $(e.target).closest(WISHLIST_ITEM_CLASS);
            this.toggleFromWishlist(currentListItem);
        });
        this.modal.on('show.bs.modal', () => this.trackHeap('FreelancerListAdditionModaleOpens'));
        this.modal.on('hide.bs.modal', () => this.trackHeap('FreelancerListAdditionModaleCloses'));
    }

    trackHeap(event) {
        if (window.heap) {
            window.heap.track(event);
        }
    }

    async getSwitchComponentAndAddListener() {
        this.$wishlistCollaborativeSwitch = await this.wishListCreationModal.querySelector('joy-toggle');

        if (this.$wishlistCollaborativeSwitch) {
            this.$wishlistCollaborativeSwitch.addEventListener('value-change', this.updateWishListCollaborativeStatus);
        }
    }

    updateWishListCollaborativeStatus(ev) {
        /**
         * Webcompnent custom event
         */
        this.wishListCollaborativeValue = ev.detail;
    }

    clean() {
        this.wishlistCreationBtn.off('click');
        this.wishlistCancelCreationBtn.off('click');
        this.wishlistCreateBtn.off('click');
        this.wishlistsList.off('click');
        this.wishlistSearchInput.off('change keyup');
        this.modal.off('show.bs.modal');
        this.modal.off('hide.bs.modal');

        if (this.$wishlistCollaborativeSwitch) {
            this.$wishlistCollaborativeSwitch.removeEventListener('value-change', this.updateWishListCollaborativeStatus);
        }
    }
}
